<template>
    <div class="row justify-content-center">
        <div class="col-12 col-xxl-11">
            <div class="row">
                <div class="col-12 faq-item" v-for="(faq, index) in faqs" :key="index">
                    <div class="faq-item-inner position-relative py-4" style="border-top: 4px solid #22733E;">

                        <div class="caret-down position-absolute c-pointer me-xxl-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="currentColor" viewBox="0 0 16 16" @click.prevent="setEl">
                                <path d="M3.204 5h9.592L8 10.481zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659" />
                            </svg>
                        </div>
                        <div class="faq pe-4 pe-lg-5">
                            <p class="fs-1-8 semibold mb-0" style="line-height:1.2;" v-html="faq.req"></p>
                        </div>
                        <div class="slide-content faq-response pe-4 pe-xl-5" data-target="slide-content">
                            <p class="mt-4 mb-0" v-html="faq.answ"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['faqReq'],
    data() {
        return {
            allRespEl: {},
            faqs: []
        }
    },
    methods: {
        setEl(e) {
            const el = e.target.closest('.faq-item-inner')

            for (const child of el.children) {
                if (typeof child.className.includes !== `undefined`) {
                    if (child.className.includes("faq-response")) {
                        child.classList.remove('slide-up')
                        child.classList.add('slide-down')
                    }
                    if (child.className.includes('caret-down') && !child.className.includes('dg-180')) {
                        this.setAllItemsHidden(el.children)
                        child.classList.add('dg-180')
                    } else if(child.className.includes('caret-down') && child.className.includes('dg-180')) {
                        child.closest('.faq-item-inner').querySelector('.faq-response').classList.add('slide-up')
                        child.closest('.faq-item-inner').querySelector('.faq-response').classList.remove('slide-down')
                        this.setAllItemsHidden()
                        break;
                    }
                } else {
                    if (child.className.includes('dg-180')) {
                        child.classList.add('dg-180')
                    }
                }
            }
        },

        setAllItemsHidden() {
            for (const it of this.allRespEl) {
                it.classList.remove('slide-down')
            }
            const carets = document.getElementsByClassName('caret-down')
            for (const caret of carets) {
                caret.classList.remove('dg-180')
            }
        }
    },

    mounted() {
        this.faqs = JSON.parse(this.faqReq)
        const allItems = document.getElementsByClassName('faq-response')
        this.allRespEl = allItems
    }
}
</script>
<style scoped>
.caret-down {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}
.faq-item:last-child > div {
    border-bottom: 4px solid #22733E;
}
.faq-response {
    transition: all .3s ease-in;
}
</style>